import { useEffect, useState } from "react";

/**
 * Returns true if the viewport is narrower than `breakpoint` (default 1024px).
 * Pure viewport-width check — does NOT consider touch capability, so
 * touchscreen laptops are correctly treated as "desktop" when wide enough.
 * Re-evaluates on resize / orientationchange.
 */
export default function useIsNarrowScreen(breakpoint = 1024) {
  const compute = () => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
  };
  const [narrow, setNarrow] = useState(compute);
  useEffect(() => {
    const onChange = () => setNarrow(compute());
    window.addEventListener("resize", onChange);
    window.addEventListener("orientationchange", onChange);
    return () => {
      window.removeEventListener("resize", onChange);
      window.removeEventListener("orientationchange", onChange);
    };
  }, []);
  return narrow;
}
